import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { AppConfig } from '../app.config';
import { HttpService } from './http.service';
import { DIMBO_CONSTANT } from '../utils/constant';
import { CacheService } from './cache.service';

@Injectable({
  providedIn: 'root'
})
export class VehicleInfoService {
  domain: string;

  constructor(private http: HttpClient , private apiconfig :AppConfig,
    private httpservice:HttpService, private cacheService: CacheService) {
      var apipath='';
        if(this.apiconfig.mpsaFlag==='N'){
          apipath = location.protocol + '//' + this.apiconfig.apiUrl;
        }

      this.domain = apipath+this.apiconfig.apiPath;
     }

  
  getVehicleInfo() {
   // console.log('Vehicle Info '+this.apiconfig.apiPath);
   // let domain = this.apiconfig.apiPath;
    let vin =this.cacheService.getItem(DIMBO_CONSTANT.CACHE_JWT_VIN);
    let finalURL=this.domain+'/'+vin+'/vehicle-information';
    
    if (DIMBO_CONSTANT.FCA_BRANDS.includes(this.cacheService.getItem(DIMBO_CONSTANT.CACHE_BRAND))) {
      finalURL = this.domain+DIMBO_CONSTANT.FCA_VEHICLE_INFORMATION.replace("{vin}",vin);
    }

    let options = {
      headers: {
        country:!this.cacheService.getItem(DIMBO_CONSTANT.CACHE_JWT_REPAIRER_COUNTRY) ? 'FR' : this.cacheService.getItem(DIMBO_CONSTANT.CACHE_JWT_REPAIRER_COUNTRY),
        language:!this.cacheService.getItem(DIMBO_CONSTANT.CACHE_LANGUAGE_LOCAL) ? 'en-GB' : this.cacheService.getItem(DIMBO_CONSTANT.CACHE_LANGUAGE_LOCAL),
        mileage:""+this.cacheService.getItem(DIMBO_CONSTANT.CACHE_JWT_MILEAGE),
        mileageUnit:!this.cacheService.getItem(DIMBO_CONSTANT.CACHE_JWT_MILEAGE_UNIT) ? '' : this.cacheService.getItem(DIMBO_CONSTANT.CACHE_JWT_MILEAGE_UNIT),
        userEditVehicleInfoClickCheck:this.cacheService.getItem(DIMBO_CONSTANT.EDIT_VEHICLE_INFO_CHECK),
        'Content-Type': 'application/json; charset=utf-8'
      }
    }
    return this.httpservice.getWithOptionVI(finalURL, options);

  }

  updateVehicleInfo(vehicleinfo:any){
    console.log('Vehicle Info '+this.apiconfig.apiPath);
    //let domain = this.apiconfig.apiPath;
    let vin =this.cacheService.getItem(DIMBO_CONSTANT.CACHE_JWT_VIN);
    let finalURL=this.domain+'/'+vin;
   // console.log('Vehicle Info URL'+finalURL);
    this.cacheService.setItem(DIMBO_CONSTANT.EDIT_VEHICLE_INFO_CHECK, 'true');
    const headers = new HttpHeaders().set('Content-Type', 'application/json; charset=utf-8');
    return this.http.post(finalURL,vehicleinfo, {headers: headers});
   
  }

}
